import { Module } from 'vuex';
import { IRootState } from '@/store';

import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { state, IArchivState } from './state';

export const NAME = 'archiv';
export const store: Module<IArchivState, IRootState> = {
    actions,
    getters,
    mutations,
    namespaced: true,
    state
};

export default store;
